import React from "react"

export default function MockDataWarning(props) {
  return (
    <div className="error-div">
      <div>
        {props.errors && props.errors.length > 0
          ? props.errors.map(err => <div>{err}</div>)
          : ` could not be loaded. See Getting Started in the README.`}
      </div>
      <div className="error-div-padding-top">
        Search results will be populated with sample data
      </div>
      <br />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Kendra/services/helpers/MockDataWarning.js